import { createFileRoute } from "@tanstack/react-router";
import AdminEmailList from "@/pages/AdminEmailList";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/email-list/")({
  component: () => (
    <RoleGate allow={['staff']} area="Ecosystem Email List"><AdminEmailList /></RoleGate>
  ),
});
